import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthContext";
import useModal from "../../customHooks/useModal";
import { postData } from "../../utils/postData";
import MolhamButton from "./MolhamButton";
import ShareModal from "./ShareModal";

type Props = {
  apiURL: string;
  title: string;
  auth_share_url?: string;
  btnLabel?: string;
};
const ShareBtn = ({ apiURL, title, auth_share_url, btnLabel }: Props) => {
  const [shareURL, setShareURL] = useState(null);
  const shareCount = useRef(0);

  const { locale, asPath } = useRouter();
  const { donor } = useContext(AuthContext);
  const {
    showModal: showShareModal,
    handleCloseModal: handleCloseShareModal,
    handleShowModal: handleShowShareModal,
  } = useModal();

  useEffect(() => {
    shareCount.current = 0;
  }, [asPath, locale]);

  const onShareBtnClick = async () => {
    shareCount.current++;
    if (!donor && auth_share_url) {
      setShareURL(auth_share_url);
      handleShowShareModal();
      return;
    }
    if (shareCount.current > 1 && auth_share_url) {
      setShareURL(auth_share_url || shareURL);
      handleShowShareModal();
      return;
    }
    try {
      const res = await postData(apiURL, null, null, { locale });
      setShareURL(res.data.url);
      handleShowShareModal();
    } catch (error) {
      toast.error(error.response?.data.error?.message);
    }
  };

  const { t } = useTranslation("common");

  return (
    <>
      <MolhamButton
        id="t9-share-btn"
        label={t(btnLabel) || t(`share`)}
        onClick={onShareBtnClick}
        labelClassName={"fs-lg"}
        startIcon="fe-share-2 share-btn  fs-lg"
        variant={null}
        className={
          "text-capitalize bg-faded-primary text-primary mr-2 ml-md-2 ml-0 px-3"
        }
      />

      <ShareModal
        title={title}
        shareURL={shareURL}
        showShareModal={showShareModal}
        handleCloseShareModal={handleCloseShareModal}
      />
    </>
  );
};

export default ShareBtn;
